export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        acronym: value.acronym,
        parent: value.parent
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        name: value.name,
        acronym: value.acronym,
        parent: value.parent
      })
    }
  },
  CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'name', 'acronym', 'parent']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.resources = value.resources || []
    } else {
      state.current = {
        id: '',
        name: '',
        acronym: '',
        parent: null,
        resources: []
      }
      state.update = {
        id: '',
        name: '',
        acronym: '',
        parent: null
      }
    }
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  UPDATE_ACRONYM (state, value) {
    state.update.acronym = value
  },
  UPDATE_PARENT (state, value) {
    state.update.parent = value
  }
}
